interface AvatarProps {
  firstName: string;
  lastName: string;
  size?: "sm" | "md" | "lg";
  imageUrl?: string;
}

const sizeMap = {
  sm: "w-7 h-7 text-2xs",
  md: "w-9 h-9 text-sm",
  lg: "w-12 h-12 text-base",
};

function getInitialsColor(name: string): string {
  const colors = [
    "bg-forest-600",
    "bg-bark-600",
    "bg-amber-500",
    "bg-forest-800",
    "bg-bark-400",
  ];
  const idx = name.charCodeAt(0) % colors.length;
  return colors[idx];
}

export function Avatar({ firstName, lastName, size = "md", imageUrl }: AvatarProps) {
  const initials = `${firstName[0] ?? ""}${lastName[0] ?? ""}`.toUpperCase();
  const colorClass = getInitialsColor(firstName + lastName);

  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt={`${firstName} ${lastName}`}
        className={`rounded-full object-cover flex-shrink-0 ${sizeMap[size]}`}
      />
    );
  }

  return (
    <div
      className={`rounded-full flex items-center justify-center flex-shrink-0 text-white font-semibold ${colorClass} ${sizeMap[size]}`}
      aria-label={`${firstName} ${lastName}`}
    >
      {initials}
    </div>
  );
}
